import { dynamicFailed } from "../hooks/useToast";
import { ICooperativeDetails } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchCooperativeDetails = async (
  id: number,
): Promise<ICooperativeDetails | null> => {
  try {
    const response = await axiosClient.get<ICooperativeDetails | null>(
      `/registers/${id}`,
    );
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return null;
  }
};
